import axios from "axios";

import { API_URL } from "../constants/config";

const USERS_BASE = `${API_URL}/api/users`;

/**
 * Normalize common API shapes: array, { users }, single user object.
 */
export const normalizeUsersResponse = (data) => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.users)) return data.users;
    if (Array.isArray(data.data)) return data.data;
    if (typeof data === "object" && (data.username || data._id || data.email)) {
        return [data];
    }
    return [];
};

/**
 * @param {string} encodedBasicCredentials - value stored after login (btoa of `user:pass`), sent as `Authorization: Basic …`
 */
export const fetchUsersList = async (encodedBasicCredentials) => {
    if (!encodedBasicCredentials) {
        throw new Error("Not authenticated");
    }
    const response = await axios.get(USERS_BASE, {
        headers: {
            Authorization: `Basic ${encodedBasicCredentials}`,
        },
        timeout: 30000,
    });
    return normalizeUsersResponse(response.data);
};
